export default __webpack_public_path__ + "static/media/logo512.e6eeaf8f.png";